const CSS_CLASSES = {
	CONTAINER: 'root__container',

	TITLE_HOME: 'title__home',
};

export { CSS_CLASSES };
